var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.5 7c.6 0 1 .4 1 1v8c0 .6-.4 1-1 1s-1-.4-1-1V8c0-.6.4-1 1-1M14.5 7c.6 0 1 .4 1 1v8c0 .6-.4 1-1 1s-1-.4-1-1V8c0-.6.4-1 1-1",
    clipRule: "evenodd"
  })));
};
export default SvgPause;